module.exports = __webpack_public_path__ + "img/portada_arriba_izq.dbab0f4f.png";